import http from 'plugins/axios';

export default {
  reqMerchants(data) {
    return http.get({
      url: '/admin/merchant/list',
      data
    });
  },
  addMerchant(id) {
    return http.post({
      url: '/admin/merchant/add',
      data: {
        userId: id
      },
      dataType: 'form'
    });
  },
  removeMerchant(id) {
    return http.post({
      url: '/admin/merchant/delete',
      data: {
        id
      },
      dataType: 'form'
    });
  }
};
